class SubscriptionsSection extends HTMLElement {
  constructor() {
    super();
    // this.attachShadow({ mode: "open" });
    this.subscriptions = [];
    this.subscriptionsTotal = 0;
    this.currencyCode = "$";
    this.email = null;
    this.order = "dsc";
    this.status = "";
  }

  connectedCallback() {
    const title1 = this.getAttribute("title1");
    const title2 = this.getAttribute("title2");
    const title3 = this.getAttribute("title3");
    const title4 = this.getAttribute("title4");
    this.currencyCode = this.dataset.currencyCode;
    this.email = this?.dataset?.email || null;
    // this.email = "Daniyal.Anwaar@powerhouse.so";
    console.log(this.dataset);

    this.render(title1, title2, title3, title4);
    this.fetchSubscriptions();
    this.addEventListeners();
  }

  async fetchSubscriptions() {
    console.log("FETCH==>>", this.email);

    const url = `https://api.summitmetals.com/api/subscriptions/get-subscriptions?email=${this.email}&order=${this.order}&status=${this.status}`;
    const headers = {
      Authorization:
        "12a35535c305f6b9d1c90ee73f7a4be5e869304eacf0e3474e556118b1e2b90c",
    };

    try {
      const response = await fetch(url, { method: "GET", headers });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const res = await response.json();
      this.subscriptions = res?.data?.subscriptions || [];
      this.subscriptionsTotal = res?.data?.total || 0;
      console.log(this.subscriptions, this.subscriptionsTotal);
      this.renderSubscriptions();
    } catch (error) {
      console.error("There was a problem fetching the subscriptions:", error);
    }
  }

  async cancelSubscription(subscriptionId) {
    console.log("CANCEL Subscription ===>>>", subscriptionId);

    const url = `https://api.summitmetals.com/api/shopify/cancel_subscription_from_order`;
    const headers = {
      Authorization:
        "12a35535c305f6b9d1c90ee73f7a4be5e869304eacf0e3474e556118b1e2b90c",
      "Content-Type": "application/json",
    };

    if (!subscriptionId) {
      return;
    }

    try {
      const response = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify({ id: subscriptionId }),
      });
      if (!response.ok) {
        console.log(response);
        throw new Error("Network response was not ok");
      }

      const res = await response.json();
      console.log(res);
      //   this.subscriptions = res?.data?.subscriptions || [];
      //   this.subscriptionsTotal = res?.data?.total || 0;
      //   console.log(this.subscriptions, this.subscriptionsTotal);
      //   this.renderSubscriptions();
      await this.fetchSubscriptions();
      this.renderSubscriptions();
    } catch (error) {
      console.error("There was a problem fetching the subscriptions:", error);
    }
  }

  render(t1, t2, t3, t4) {
    this.innerHTML = `
      <div class="SM-filt-sort">
        <div class="SMtabs">
          <h2>Your Autopays</h2>
        </div>
        <div class="SMfilters">
          <div class="Smfilt-con">
            <select id="filter">
              <option>All</option>
              <option>Newest</option>
              <option>Oldest</option>
              <option>Active</option>
              <option>Pending</option>
              <option>Cancelled</option>
            </select>
          </div>
        </div>
      </div>
      <div class="SMsubs-titles">
        <div class="SMsubs-tit-con">
          <h2>${t1}</h2>
        </div>
        <div class="SMsubs-tit-con">
          <h2>${t2}</h2>
        </div>
        <div class="SMsubs-tit-con">
          <h2>${t3}</h2>
        </div>
        <div class="SMsubs-tit-con">
          <h2>${t4}</h2>
        </div>
      </div>
      <div id="subscriptions-list" class="SMsubscription-list"></div>
    `;
  }

  renderSubscriptions() {
    const subscriptionList = this.querySelector("#subscriptions-list");
    subscriptionList.innerHTML = ""; // Clear previous content
    if (this.subscriptions.length == 0) {
      subscriptionList.innerHTML =
        '<p class="details-text">No autopays found.</p>';
      return;
    }
    this.subscriptions.forEach((sub, index) => {
      const subscriptionItem = document.createElement("div");
      subscriptionItem.classList.add("SMsubscription-item");

      const createdDate = new Date(sub?.createdAt);
      const date = new Date(sub?.updatedAt);
      const renewalDate = new Date(sub?.renewalDate);

      const createdMonth = createdDate.toLocaleString("en-US", {
        month: "short",
        timeZone: "UTC",
      });
      const createdYear = createdDate.getUTCFullYear();
      const createdDay = createdDate.getUTCDate();
      const formattedCreatedDate = `${createdMonth} ${createdDay}, ${createdYear}`

      const updatedMonth = date.toLocaleString("en-US", {
        month: "short",
        timeZone: "UTC",
      });
      const updatedYear = date.getUTCFullYear();
      const updatedDay = date.getUTCDate();
      const formattedDate = `${updatedMonth} ${updatedDay}, ${updatedYear}`;

      const renewalMonth = renewalDate.toLocaleString("en-US", {
        month: "short",
        timeZone: "UTC",
      });
      const renewalYear = renewalDate.getUTCFullYear();
      const renewalDay = renewalDate.getUTCDate();
      const formattedRenewalDate = `${renewalMonth} ${renewalDay}, ${renewalYear}`
      const price = new Intl.NumberFormat('en-US').format(sub.amount);
      subscriptionItem.innerHTML = `
          <div class="SM-image-subcr">
            <div class="SMsubs-image">
            ${sub?.image ? `<img src="${sub?.image}" alt="Product Thumbnail" class="SMproduct-img"></img>` : `<img src="https://via.placeholder.com/60" alt="Product Thumbnail" class="SMproduct-img">`}
            </div>
            <div class="SMsubscription-info">
              <div class="SMsubs-tit">
              ${sub?.title ? `<h3>${sub?.title}</h3>` : `<h3>Autopay #${index + 1}</h3>`}
              </div>
              <div class="SMdetails-toggle">
                <span class="SMview-details">View details</span>
                <span class="SMcarrot">&#9660;</span>
              </div>
              <div class="SMdetails-content">
                <span class="SMlast-updated">Order Id : ${sub.order_id}</span>
                <span class="SMlast-updated">Interval : ${sub.interval.charAt(0) + sub.interval.toLowerCase().slice(1)}</span>
                ${ sub.status === "cancelled" ? "" : `<span class="SMlast-updated">Renewal date : ${formattedRenewalDate}</span>`}
                <span class="SMlast-updated">Created at : ${formattedCreatedDate}</span>
                <span class="SMlast-updated">Last updated : ${formattedDate}</span>
              </div>
            </div>
          </div>
          <div class="SMstatus ${
            sub.status === "active" ? "SMactive" : "SMcancelled"
          }">
          ${
            sub.status === "active"
              ? `<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.6667 4L6.33333 11.3333L3 8" stroke="#55BD6C" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`
              : ""
          }
            <span>${
              sub.status.charAt(0).toUpperCase() + sub.status.slice(1)
            }</span>
          </div>
          <div class="SMprice">${this.currencyCode}${price}</div>
          ${
            sub.status == "active" ? 
            `<div class="SMaction-btn SMcancel-btn" data-subscription-id="${sub.order_id}">
                <a href="#"><span>Cancel</span>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.0625 5.9375L5.9375 14.0625L14.0625 5.9375ZM5.9375 5.9375L14.0625 14.0625L5.9375 5.9375Z" fill="#BF4A4A"/>
                        <path d="M14.0625 5.9375L5.9375 14.0625M5.9375 5.9375L14.0625 14.0625" stroke="#BF4A4A" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </a>
            </div>` : 
            sub.status == "pending" ? `<p class="action-text">N/A</p>` : `<p class="action-text">Expired</p>`
          }
        `;
      subscriptionList.appendChild(subscriptionItem);
    });

    this.addCancelEventListeners();
    this.addDetailsToggleEventListeners(); 

  }

  addDetailsToggleEventListeners() {
    const toggleButtons = this.querySelectorAll('.SMdetails-toggle');
    toggleButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const detailsContent = button.nextElementSibling;
        const carrot = button.querySelector('.SMcarrot');
        
        // Toggle visibility
        if (detailsContent.style.maxHeight) {
          detailsContent.style.maxHeight = null;
          carrot.innerHTML = '&#9660;';
        } else {
          detailsContent.style.maxHeight = detailsContent.scrollHeight + 'px';
          carrot.innerHTML = '&#9650;';
        }
      });
    });
  }
  

  addEventListeners() {
    const filterSelect = this.querySelector("#filter");
    const sortSelect = this.querySelector("#sort");

    filterSelect.addEventListener("change", (e) =>
      this.applyFilters(e.target.value)
    );
    // sortSelect.addEventListener('change', (e) => this.applyFilters(e.target.value));
  }

  addCancelEventListeners() {
    const cancelButtons = this.querySelectorAll(".SMcancel-btn");
    cancelButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        console.log(e);
        e.preventDefault();
        const subscriptionId = button.dataset.subscriptionId;
        this.showConfirmationPopup(subscriptionId);
        // this.cancelSubscription(subscriptionId);
      });
    });
  }

  showConfirmationPopup(subscriptionId) {
    const confirmationPopup = document.createElement('div');
    confirmationPopup.classList.add('confirmation-popup');
    confirmationPopup.innerHTML = `
      <div class="confirmation-content">
        <p>Are you sure you want to cancel this autopay?</p>
        <button class="confirm-btn">Yes</button>
        <button class="cancel-btn">No</button>
      </div>
    `;
    this.appendChild(confirmationPopup);
    
    // Get the buttons inside the popup
    const confirmBtn = confirmationPopup.querySelector('.confirm-btn');
    const cancelBtn = confirmationPopup.querySelector('.cancel-btn');
    
    // If user confirms, cancel the subscription
    confirmBtn.addEventListener('click', () => {
      this.cancelSubscription(subscriptionId);
      this.removePopup(confirmationPopup);
    });
    
    // If user cancels, just remove the popup
    cancelBtn.addEventListener('click', () => {
      this.removePopup(confirmationPopup);
    });
  }

  removePopup(popup) {
    popup.remove();
  }

  applyFilters(filter) {
    console.log("Filters applied", filter, filter.toLowerCase());
    switch (filter) {
      case "All":
        this.status = ""; // Reset the status to fetch all data
        break;
      case "Pending":
      case "Active":
      case "Cancelled":
        this.status = filter.toLowerCase();
        break;
      case "Newest":
      case "Oldest":
        this.order = filter == "Newest" ? "dsc" : "asc";
        break;
      default:
        break;
    }
    this.fetchSubscriptions();
  }
}

customElements.define("subscription-section", SubscriptionsSection);
